document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.ja-product-atf-cart-opps-wrapper');
  if (!wrapper) return;

  const addToCartForm = wrapper.querySelector('.ja-product-atf-cart-opps__add-to-cart-form');
  if (!addToCartForm) return;

  const numOfItemsEl = wrapper.querySelector('#ja-product-number-of-items');
  const hiddenQuantityInput = wrapper.querySelector('#hidden-quantity');
  const decreaseBtn = wrapper.querySelector('#ja-product-decrease');
  const increaseBtn = wrapper.querySelector('#ja-product-increase');
  const optionRadios = wrapper.querySelectorAll('[name="opps-input"]');
  const addToCartButton = addToCartForm.querySelector('.ja-product-atf-cart-opps__add-to-cart');

  // --- Quantity Update ---
  const updateQuantity = (newQuantity) => {
    const quantity = parseInt(newQuantity, 10);
    if (isNaN(quantity) || quantity < 1) return;

    if (hiddenQuantityInput) hiddenQuantityInput.value = quantity;
    if (numOfItemsEl) numOfItemsEl.value = quantity;

    // Miktar bazlı radio seçimi: 5+ ise "5 Al", 3-4 ise "3 Al", 1-2 ise "Tekli"
    let targetNumber;
    if (quantity >= 5) {
      targetNumber = 5;
    } else if (quantity >= 3) {
      targetNumber = 3;
    } else {
      targetNumber = 1;
    }

    optionRadios.forEach(radio => {
        const selected = radio.dataset.number == targetNumber;
        radio.checked = selected;
        radio.parentElement.classList.toggle('selected', selected);
    });
  };

  // --- Event Listeners ---
  if (decreaseBtn) {
    decreaseBtn.addEventListener('click', () => {
      const currentValue = Number(numOfItemsEl.value);
      if (currentValue > 1) updateQuantity(currentValue - 1);
    });
  }
  
  if (increaseBtn) {
    increaseBtn.addEventListener('click', () => {
        const currentValue = Number(numOfItemsEl.value);
        updateQuantity(currentValue + 1);
    });
  }

  optionRadios.forEach(input => {
    input.addEventListener('change', function() {
      updateQuantity(this.dataset.number);
    });
  });

  // --- AJAX cart ---
  addToCartForm.addEventListener('submit', function(event) {
    event.preventDefault();
    addToCartButton.disabled = true;
    addToCartButton.textContent = 'Ekleniyor...';

    const formData = new FormData(addToCartForm);
    const body = {
      items: [{
        id: formData.get('id'),
        quantity: formData.get('quantity')
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(response => {
      if (!response.ok) return response.json().then(error => { throw new Error(error.description || 'Bir hata oluştu.') });
      return response.json();
    })
    .then(addedItem => {
      return fetch('/cart.js').then(response => response.json());
    })
    .then(cart => {
      addToCartButton.textContent = 'Eklendi!';
      
      if (window.Shopify && window.Shopify.pubsub && typeof PUB_SUB_EVENTS !== 'undefined') {
        Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cart });
        
        const addedItemData = cart.items.find(item => item.variant_id == body.items[0].id);
        const toastMessage = addedItemData ? `${addedItemData.title} sepete eklendi.` : 'Ürün sepete eklendi.';

        Shopify.pubsub.publish(PUB_SUB_EVENTS.toastShow, {
          title: 'Başarılı!',
          message: toastMessage,
          type: 'success'
        });
      }
    })
    .catch(error => {
      console.error('Add to Cart Error:', error);
      addToCartButton.textContent = 'Hata Oluştu';
      
      if (window.Shopify && window.Shopify.pubsub && typeof PUB_SUB_EVENTS !== 'undefined') {
        Shopify.pubsub.publish(PUB_SUB_EVENTS.toastShow, {
          title: 'Hata Oluştu',
          message: error.message || 'Ürün sepete eklenemedi.',
          type: 'error'
        });
      }
    })
    .finally(() => {
      setTimeout(() => {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Sepete Ekle';
      }, TOAST_DURATION || 4000);
    });
  });
});